import React, { useCallback, useEffect, useState } from 'react';
import CustomCheckBox from '~/components/layout/CustomCheckBox';
import { getDownloadTechnicalDocuments } from '~/services/technicalDocumentationServices';

import {
  Container,
  WrapFileDetails,
  TitleFileLabel,
  TitleFile,
  CheckBoxContainer,
  DetailsContainer,
  ActionsContainer,
  InformationIconInActive,
  InformationIconActive,
  ActionsWrap,
  DownLoadIcon,
  MailIcon
} from './styles';

function FileItem({
  siteId,
  handleSelectItem,
  isCheckedItem,
  itemId,
  label,
  title,
  description,
  setShowModal,
  link,
  setOriginUnique,
  originUnique,
  clearSelected,
}) {
  const [isChecked, setIsChecked] = useState(false);
  const [loader, setLoader] = useState(false);
  const [showDescription, setShowDescription] = useState(false);

  useEffect(() => {
    setIsChecked(isCheckedItem);
  },[isCheckedItem])

  useEffect(() => {
    handleSelectItem(itemId, isChecked)
  },[isChecked, itemId])

  const handleDownloadDocument = useCallback(async () => {
    const contactIdSf = localStorage.getItem('@UltragazEmpresarial:contactIdSf');
    setLoader(true);
    await getDownloadTechnicalDocuments({
      customerSiteId: siteId,
      deliveryMethod: "DOWNLOAD",
      link,
      documentName: title,
      contactIdSf
    });
    setLoader(false);
  }, [siteId, title, link])

  return (
    <Container>
      <DetailsContainer active={showDescription}>
        <CheckBoxContainer>
          <CustomCheckBox
            isChecked={isChecked && !originUnique}
            setIsChecked={setIsChecked}
            includeMarginTop={16}
            />
        </CheckBoxContainer>
        <WrapFileDetails>
          <TitleFileLabel>
            {!loader && !showDescription &&  label}
            {!loader && showDescription && 'Descricão'}
          </TitleFileLabel>
          <TitleFile>
            {loader ? 'Aguarde...' : !showDescription && title}
            {!loader && showDescription && description}
          </TitleFile>
        </WrapFileDetails>
      </DetailsContainer>
      <ActionsContainer>
        <ActionsWrap>
          {showDescription && (
            <InformationIconActive size={22} color="#0b29fb" onClick={() => {
              setShowDescription(!showDescription);
            }} />
          )}
          {!showDescription && (
            <InformationIconInActive size={22} color="#0b29fb" onClick={() => {
              setShowDescription(!showDescription);
            }}/>
          )}
          <MailIcon size={22} color="#0b29fb" onClick={() => {
            clearSelected();
            setTimeout(() => {
              setShowModal(true);
              setIsChecked(true);
              setOriginUnique(true);
            },500);
          }} />
          <DownLoadIcon size={22} color="#0b29fb" onClick={() => handleDownloadDocument()} />
        </ActionsWrap>
      </ActionsContainer>
    </Container>
  );
}

export default FileItem;
